export default "__VITE_ASSET__CPdgb5RZ__"